module.exports = __webpack_public_path__ + "img/bronze.4f8680f0.png";